import { render, staticRenderFns } from "./CustomerOrderedHistory.vue?vue&type=template&id=5ca4a360&scoped=true"
import script from "./CustomerOrderedHistory.vue?vue&type=script&lang=js"
export * from "./CustomerOrderedHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4a360",
  null
  
)

export default component.exports